module.exports = __webpack_public_path__ + "img/cresc_banner.e9245b2e.png";